import y from "../../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import { supportRef as _, composeRef as k } from "../../../rc-util/es/ref.mjs";
import * as e from "react";
import N from "../../../rc-util/es/Dom/findDOMNode.mjs";
import { observe as q, unobserve as z } from "../utils/observerUtil.mjs";
import B from "./DomWrapper.mjs";
import { CollectionContext as D } from "../Collection.mjs";
function F(f, x) {
  var s = f.children, h = f.disabled, r = e.useRef(null), l = e.useRef(null), d = e.useContext(D), m = typeof s == "function", o = m ? s(r) : s, n = e.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), p = !m && /* @__PURE__ */ e.isValidElement(o) && _(o), v = p ? o.ref : null, I = e.useMemo(function() {
    return k(v, r);
  }, [v, r]), g = function() {
    return N(r.current) || N(l.current);
  };
  e.useImperativeHandle(x, function() {
    return g();
  });
  var R = e.useRef(f);
  R.current = f;
  var E = e.useCallback(function(t) {
    var H = R.current, b = H.onResize, O = H.data, w = t.getBoundingClientRect(), a = w.width, c = w.height, u = t.offsetWidth, i = t.offsetHeight, C = Math.floor(a), W = Math.floor(c);
    if (n.current.width !== C || n.current.height !== W || n.current.offsetWidth !== u || n.current.offsetHeight !== i) {
      var $ = {
        width: C,
        height: W,
        offsetWidth: u,
        offsetHeight: i
      };
      n.current = $;
      var S = u === Math.round(a) ? a : u, V = i === Math.round(c) ? c : i, M = y(y({}, $), {}, {
        offsetWidth: S,
        offsetHeight: V
      });
      d == null || d(M, t, O), b && Promise.resolve().then(function() {
        b(M, t);
      });
    }
  }, []);
  return e.useEffect(function() {
    var t = g();
    return t && !h && q(t, E), function() {
      return z(t, E);
    };
  }, [r.current, h]), /* @__PURE__ */ e.createElement(B, {
    ref: l
  }, p ? /* @__PURE__ */ e.cloneElement(o, {
    ref: I
  }) : o);
}
var P = /* @__PURE__ */ e.forwardRef(F);
process.env.NODE_ENV !== "production" && (P.displayName = "SingleObserver");
export {
  P as default
};
//# sourceMappingURL=index.mjs.map
